module.exports = __webpack_public_path__ + "static/quote@2x-b2d355a1502bcc1efc3649b5813fc068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/mode/quote@2x.jpg
// module id = 402
// module chunks = 3627797113349 20562973939449 33019919093843